import { isNil, isString } from 'lodash';
import { EditableField, Field } from './Field';

export type EntitiesScheduleRef =
  MBAPI.ListWorkflowEntitiesQuery_list_refs_recurringEntitiesScheduleRefs;

export class EntityBatchField implements EditableField {
  readonly fieldType = 'EntityBatch';
  readonly id: string;
  readonly refs: EntitiesScheduleRef[];

  constructor(id: string, refs?: EntitiesScheduleRef[] | null) {
    this.id = id;
    this.refs = refs ?? [];
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof EntityBatchField && this.id === field.id;
  }

  toFieldJson() {
    return this.id;
  }

  get isEmpty() {
    return isNil(this.id);
  }

  static fromFieldJson(jsonBlob: MBAPI.Scalar.JSON, refs?: EntitiesScheduleRef[] | null) {
    if (isString(jsonBlob)) {
      return new EntityBatchField(jsonBlob, refs);
    } else {
      return null;
    }
  }
}

export function isEntityBatchField(field?: Field | null): field is EntityBatchField {
  return field instanceof EntityBatchField;
}
